module.exports = __webpack_public_path__ + "static/media/aramark-logo.b92a0194.png";